<script setup>
import {useTemplateRef, watch, watchPostEffect} from 'vue';
import {activeStore, filteredStores, formatDistance, isActiveStore, services} from '../../stores/storeMap';

const storeListElement = useTemplateRef('storeList');

watch(filteredStores, () => {
    storeListElement.value.scrollTo(0, 0);
});

watchPostEffect(() => {
    if (activeStore.value) {
        storeListElement.value.querySelector('.is-active').scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            container: 'nearest',
        });
    }
});
</script>

<template>
    <ul class="store-list-list" ref="storeList">
        <li v-for="(store, i) in filteredStores"
            class="store-list-item"
            :class="{'is-active': isActiveStore(store)}"
            :key="store.id">
            <p class="store-list-item-name">
                <span>{{ store.name }}</span>
                <small v-if="store.distance !== null">({{ formatDistance(store.distance) }})</small>
            </p>
            <p v-if="store.phoneNumber" class="store-list-item-phone-number">{{ store.phoneNumber }}</p>
            <address class="store-list-item-address">
                {{ store.address }}<br>{{ store.postalCode }}&nbsp;{{ store.city }}
            </address>
            <template v-if="store.services.length">
                <p><strong>Services :</strong></p>
                <ul>
                    <li v-for="service in store.services">{{ services[service] }}</li>
                </ul>
            </template>
            <button type="button"
                    class="button is-small"
                    @click="activeStore = store"
                    v-if="!activeStore || !isActiveStore(store)">
                Voir
            </button>
            <button type="button"
                    class="button is-small"
                    @click="activeStore = null"
                    v-else-if="isActiveStore(store)">
                Fermer
            </button>
        </li>
        <li v-if="!filteredStores.length" class="store-list-item">
            <p>Aucune boutique correspondant à votre recherche.</p>
        </li>
    </ul>
</template>
